import { PageHero } from "@/components/sections/PageHero";
import { CTABand } from "@/components/sections/CTABand";
import { PROCESS, IMAGES } from "@/lib/site";

export default function Process() {
  return (
    <div data-testid="process-page">
      <PageHero
        eyebrow="Our Process"
        title={<>Seven steps.<br /><span className="text-[#FF5722]">Zero</span> guesswork.</>}
        subtitle="Every part that comes through the door follows the same disciplined production process — from request to packaged shipment."
        image={IMAGES.welding}
      />

      <section className="section px-6 lg:px-10">
        <div className="border-t border-white/10">
          {PROCESS.map((p, idx) => (
            <div
              key={p.n}
              className="grid grid-cols-1 lg:grid-cols-12 gap-8 py-12 border-b border-white/10 items-start"
              data-testid={`process-step-${p.n}`}
            >
              <div className="lg:col-span-2 font-display text-6xl md:text-7xl text-[#FF5722] leading-none tracking-tighter">{p.n}</div>
              <div className="lg:col-span-4">
                <h3 className="font-display text-3xl md:text-4xl tracking-tight">{p.title}</h3>
              </div>
              <div className="lg:col-span-6">
                <p className="text-zinc-300 leading-relaxed text-lg">{p.body}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
